import {defineStore} from 'pinia';
import {computed, ref, watch} from 'vue';
import LocalStorageDecorator from '@/store/storage/local-storage-decorator';
import { useAnalytics } from '@/composables/useAnalytics';

export interface TermOfUseStore {
    isConfirm: boolean;
}

export const useTermOfUseStore = defineStore('termOfUseStore', () => {
    const isConfirm = ref(false)
    const analytics = useAnalytics();

    function resetData() {
        isConfirm.value = false;
    }

    const isTermOfUseStepValid = computed(() => {
        return isConfirm.value;
    })

    function setTermOfUseConfirmation(value: boolean) {
        isConfirm.value = value;
    }

    function exportData() {
        return {
            isConfirm: isConfirm.value
        }
    }

    function importData(data: TermOfUseStore) {
        isConfirm.value = data.isConfirm;
    }

    watch(isTermOfUseStepValid, (valid) => {
        if (valid) {
            analytics.sendEvent('card_completed_terms');
        }
    });

    return { setTermOfUseConfirmation, isTermOfUseStepValid, isConfirm, resetData, exportData, importData }
},{
    persist: {
        storage: LocalStorageDecorator
    },
});
